import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import * as Chart from 'chart.js';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { UserService } from '../user.service';
import { Spanish } from 'flatpickr/dist/l10n/es';

@Component({
  selector: 'app-rangoshora',
  templateUrl: './rangoshora.component.html',
  styleUrls: ['./rangoshora.component.scss']
})
export class RangoshoraComponent implements OnInit {

  chart1; chart2; chart3;

  fecha_desde: string = this.user.getLastMonth();
  fecha_hasta: string = this.user.formatDate(new Date());

  data: any = [];

  salas = [
    { 'id': '17' , 'nombre': 'Bingo Riscal'},
    { 'id': '20' , 'nombre': 'Bingo Costa Blanca'},
    { 'id': '21' , 'nombre': 'Bingo Navas'},
    { 'id': '22' , 'nombre': 'Bingo Gorrion'},
  ];

  sala_id = '21';

  fecha_desde_conf: FlatpickrOptions = {
    enableTime: false,
    locale: Spanish,
    defaultDate : this.fecha_desde,
    dateFormat: 'Y-m-d',
    onChange: (selectedDates, dateStr, instance) => {
      this.fecha_desde = dateStr;
    }
  };

  fecha_hasta_conf: FlatpickrOptions = {
    enableTime: false,
    locale: Spanish,
    defaultDate : this.fecha_hasta,
    dateFormat: 'Y-m-d',
    onChange: (selectedDates, dateStr, instance) => this.fecha_hasta = dateStr
  };

  constructor(
    public rest: RestService,
    public user: UserService,
  ) {
  }

  ngOnInit() {
    this.chart1 = this.mixedChart('mix1', 'Diferencias por fechas de Bingo Electrónico VS Tradicional');
    // this.chart2 = this.mixedChart('mix2', 'Diferencias de Bingo Electrónico y Tradicional por mes de la franja horaria : 14:00H - 17:00H');
    // this.chart3 = this.mixedChart('mix3', 'Diferencias de Bingo Electrónico y Tradicional por mes de la franja horaria : 17:00H - 21:00H');
    setTimeout(() => {
      this.getData();
    }, 500);
  }

  private mixedChart(nombre, textTitle) {
    return new Chart(document.getElementById(nombre), {
      type: 'bar',
      data: {
        labels: [
          'Enero', 'Febrero', 'Marzo',
          'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiempre',
          'Octubre', 'Noviembre', 'Diciembre'
        ],
        datasets: [
          {
            label: 'Diferencias Porcentaje',
            type: 'bar',
            borderWidth: 1,
            backgroundColor: 'gray',
            data: [],
            fill: true,
            hidden: false
          },
          {
            label: 'Diferencias Bruto',
            type: 'bar',
            borderWidth: 1,
            backgroundColor: 'lightgray',
            data: [],
            fill: true,
            hidden: false
          },
          {
            label: 'Electrónico',
            type: 'bar',
            borderWidth: 1,
            backgroundColor: '#1B4A73',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'Tradicional',
            borderWidth: 1,
            backgroundColor: '#9D394F',
            data: [],
            fill: true,
            hidden: true
          },
          {
            label: 'Electrónico AA',
            type: 'bar',
            borderWidth: 1,
            borderColor: '#2e8ada',
            data: [],
            fill: false,
            hidden: true
          },
          {
            label: 'Tradicional AA',
            borderWidth: 1,
            borderColor: '#ff9cb2',
            data: [],
            fill: false,
            hidden: true
          },
        ]
      },
      options: {
        title: {
          display: true,
          text: textTitle
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            callbacks: {
              label: function(tooltipItem, data) {
                  return tooltipItem.yLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              },
            }
          }
        },
        scales: {
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true
            },
            ticks: {
              beginAtZero: true,
              userCallback: function(value, index, values) {
                value = value.toString();
                value = value.split(/(?=(?:...)*$)/);
                value = value.join('.');
                return value;
              }
            }
          }],
        },
        events: ['click'],
        legend: {
          display: true,
          labels: {
            boxWidth: 70,
            fontSize: 16
          }
        },
        maintainAspectRatio: true,
        responsive: true
      }
    });
  }

  getData() {
    this.user.loading = true;

    const empty_array = new Promise ( (resolve) => {
        for (let indice = 0; indice < this.chart1.data.datasets.length; indice++) {
          this.chart1.data.datasets[indice].data.length = 0;
        }
        resolve();
      });

    empty_array.then( (ok) => {

      this.rest.GetFacturacionPorRangosHora(this.sala_id, this.fecha_desde, this.fecha_hasta)
      .subscribe( (data) => {

        const promise_data = new Promise( (resolve) => {
          this.chart1.data.labels = data['status_message'];

          for (let index = 0; index < data['data'].length; index++) {
            for (let index2 = 0; index2 < data['data'][index].datos.length; index2++) {
              new Intl.NumberFormat('de-DE').format(
                this.chart1.data.datasets[index].data.push( data['data'][index].datos[index2].jugado
                  .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' })
                )
              );
            }
          }
          resolve();
        });

        promise_data.then( (ok) => {
          setTimeout(() => {
            this.user.loading = false;
            this.chart1.update();
            console.log('OK', this.chart1.data.datasets );
          }, 500);
        });

      }, (error) => { this.user.loading = false;});
    });

  }

}
